import { Table } from 'antd';
import React from 'react';
import { Enrollment } from 'src/types/enrollment';
import { mobileMasking } from 'src/utils/masking';

import { ExpandedRowRender } from './ExpandedRowRender';

interface Props {
  enrollments: Enrollment[];
  children: React.ReactNode;
  loading: boolean;
}
export const MainTable = (props: Props) => {
  const { enrollments, loading } = props;
  const newEnrollments = JSON.parse(JSON.stringify(enrollments));
  let maskedUserMobileEnrollments: Enrollment[] = [];
  if (newEnrollments) {
    maskedUserMobileEnrollments = newEnrollments.map(enrollment => {
      const newEnrollment = enrollment;
      if (enrollment && enrollment.user && enrollment.user.mobile) {
        newEnrollment.user.mobile = mobileMasking(enrollment.user.mobile);
      }
      return newEnrollment;
    });
  }
  return (
    <Table
      scroll={{ x: 2000, y: 550 }}
      dataSource={maskedUserMobileEnrollments}
      pagination={false}
      rowKey={record => `${record.id}`}
      expandedRowRender={(record: Enrollment) => <ExpandedRowRender record={record} />}
      loading={loading}
    >
      {props.children}
    </Table>
  );
};



// WEBPACK FOOTER //
// ./src/screens/group/GroupDetailMainTable.tsx